import { useLazyQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import SEARCH_IMG from '../../assets/images/search.svg';
import ContentViewModal from "../../components/ContentViewModal";
import CustomButton from "../../components/layout/CustomButton";
import Loader from "../../components/layout/Loader";
import NoDataFound from "../../components/layout/NoDataFound";
import TableComponent from "../../components/layout/TableComponent";
import { ICSVImportsData } from "../../interfaces";
import { ADMIN_IMPORTS_HEADER, ALL_IMPORTS_HEADER, PAGE_LIMIT } from "../../utils/constant";
import ModalUpload from "./ModalUpload";
import { LIST_DATA_CSV_IMPORTS} from "./gql";
import { LOOKUP_IMPORTS } from "../../constants";
import { mapListData } from "./mapListData";
import CSVTablePagination from "./csvTablePagination";

const AllImports = ({ adminImport }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isOpenErrorModal, setIsOpenErrorModal] = useState<boolean>(false)
  const [ErrorMessage, setErrorMessage] = useState<string>()
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [fileName, setFileName] = useState<string>('')
  const [listDataCSVImports, { data: listData, loading: listLoading, refetch }] = useLazyQuery(LIST_DATA_CSV_IMPORTS);

  const listCSVImports = useCallback(async () => {
    if (fileName === '') {
      await listDataCSVImports({
        variables: {
          adminImport,
          limit,
          fileName: '',
          page: currentPage,
        },
      });
    }
  }, [currentPage, limit, fileName, listDataCSVImports]);

  useEffect(() => {
    listCSVImports();
  }, [listCSVImports]);

  // const deleteEntry = async () => {
  //   try {
  //     const response = await removeDataCSVImport({ variables: { id: recordId } })
  //     if (response?.data?.removeDataCsvImport?.status === 200) {
  //       toast.success("Successfully deleted!")
  //       refetch()
  //     }
  //   }
  //   catch {
  //     toast.error("Error while deletion!")
  //   }
  //   setDeleteStatus(false)
  // }

  const searchControl = async (value: any) => {
    setFileName(value);
    if (value?.length > 2) {
      await listDataCSVImports({
        variables: {
          limit: 10,
          fileName: value,
          adminImport,
          page: 1,
        },
      });
    }
  };

  return (
    <>
      <h5 className="m-0 mb-4">{LOOKUP_IMPORTS}</h5>
      <div className="search-filter primaryHeaderSpacing">
        <div>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <img src={SEARCH_IMG} alt="search" />
              </InputGroupText>
            </InputGroupAddon>
            <Input type="text" placeholder="Search File Name"
              value={fileName} onChange={(e) => searchControl(e.target.value)} className="search-by-company"
            />
          </InputGroup>
          <small className="text-info">
            {fileName &&
              fileName.length <= 2 &&
              "Please add more than two characters"}
          </small>
        </div>
        <div className="filter-status">
          <div className="filter-by">
            <CustomButton className="ml-auto" buttonText="Import CSV"
              buttonClick={() => setIsOpen(!isOpen)}
            />
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <TableComponent tableHeader={adminImport ? ADMIN_IMPORTS_HEADER : ALL_IMPORTS_HEADER}>
          <tbody>
            {listLoading && (
              <td colSpan={14}>
                <Loader loaderClass="sm-height " />
              </td>
            )}
            {!listLoading && !listData?.listDataCsvImport?.dataCsvImports?.length && (
              <td colSpan={14} className="empty-table-td">
                <NoDataFound text="No Record Found!" />
              </td>
            )}
            {!listLoading && listData?.listDataCsvImport?.dataCsvImports?.map((item: ICSVImportsData, index: number) => {
              return <tr key={index}>
              {mapListData({
                data: item,
                adminImport,
                setErrorMessage,
                setIsOpenErrorModal,
                refetch,
              })}
            </tr>
            })}
          </tbody>
        </TableComponent>
      </div >

      {!listLoading && !!listData?.listDataCsvImport?.dataCsvImports?.length &&
        <CSVTablePagination
          currentPage={currentPage}
          totalCount={listData?.listDataCsvImport?.count}
          limit={limit}
          pageLimitOptions={PAGE_LIMIT}
          onPageChange={setCurrentPage}
          onLimitChange={(newLimit) => {
            setCurrentPage(1);
            setLimit(newLimit);
          }}
        />
      }

      <ModalUpload isOpen={isOpen} refetch={refetch} toggle={() => setIsOpen(!isOpen)} adminImport={adminImport} />
      <ContentViewModal isOpen={isOpenErrorModal} heading={"Error Message"} toggle={() => setIsOpenErrorModal(!isOpenErrorModal)}
        content={ErrorMessage}
      />
    </>
  )
}

export default AllImports